import Transform from '@app/transformers';
import * as TransferItemsHelper from '@app/helper/transfer-items';

const sideloaded = window['__session__'] || {};
const auth = Transform.auth(sideloaded.user);
const accountId = auth.account.id;

// initial Transfer state
const transfer = {
  files: [],
  items: [],
  itemsTree: TransferItemsHelper.buildItemsTree(),
  sender: '',
  message: '',
  recipients: [],
  accountId,
};

export default transfer;
